import React from 'react';
import { Link } from 'react-router';
import EsrrBadge from '../Operations/EsrrBadge';
import { Cell } from '../../shared/components/Table';
import { dateStr } from '../../shared/misc/utils';
import { MissionItem } from '../../services/types/Missions';
import ImpactBadge from '../Operations/ImpactBadge';
import RiskBadge from '../Operations/RiskBadge';
import PerformanceBadge from '../Operations/PerformanceBadge';

const getCells = (hideColumns: string[]) => {
  const cells: Cell<MissionItem>[] = [
    {
      name: 'operationNumber',
      value: (x) => x.operationNumber,
      render: (x, o) => <Link to={`/operations/${o.operationNumber}`}>{x}</Link>,
    },
    { name: 'operationName', value: (x) => x.operationName },
    { name: 'operationType', value: (x) => x.operationType },
    {
      name: 'operationEsrr',
      value: (x) => x.operationEsrr,
      column: 'esrr',
      render: (x) => <EsrrBadge text={x} />,
    },
    {
      name: 'operationEsic',
      value: (x) => x.operationEsic,
      column: 'esic',
      render: (x) => <ImpactBadge text={x} />,
    },
    {
      name: 'operationDccrc',
      value: (x) => x.operationDccrc,
      column: 'dccrc',
      render: (x) => <RiskBadge text={x} />,
    },
    {
      name: 'operationSpr',
      value: (x) => x.operationSpr,
      column: 'spr',
      render: (x) => <PerformanceBadge code={x} />,
    },
    {
      name: 'number',
      value: (x) => x.number,
      render: (x, o) => <Link to={`/missions/${o.id}`}>{x}</Link>,
    },
    {
      name: 'type',
      value: (x) => x.type,
    },
    {
      name: 'startDate',
      value: (x) => dateStr(x.startDate),
    },
    {
      name: 'endDate',
      value: (x) => dateStr(x.endDate),
    },
    {
      name: 'status',
      value: (x) => x.status,
    },
    {
      name: 'destinationCountry',
      value: (x) => x.destinationCountry,
    },
    {
      name: 'objective',
      value: (x) => x.objective,
    },
    {
      name: 'regionCountry',
      value: (x) => x.regionCountry,
    },
    {
      name: 'members',
      value: (x) => x.members,
      sortDisabled: true,
    },
  ];

  return cells.filter(
    (c) => c.name && (!c.disable || !c.disable()) && !hideColumns.includes(c.name)
  );
};

export default getCells;
